import React, { useEffect, useState } from "react";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import { constant } from "../../../../utils/constant";

const HelpDesk = () => {
  const [loading, setLoading] = useState(true);
  function initFreshChat() {
    window.fcWidget.init({
      token: process.env.REACT_APP_FC_WIDGET_TOKEN,
      host: "https://wchat.freshchat.com",
    });
    window.fcWidget.open();
    setTimeout(() => {
      setLoading(false);
    }, 6000);
  }
  function initialize(i, t) {
    var e;
    if (i.getElementById(t)) {
      initFreshChat();
    } else {
      e = i.createElement("script");
      e.id = t;
      e.async = true;
      e.src = "https://wchat.freshchat.com/js/widget.js";
      e.onload = initFreshChat;
      i.head.appendChild(e);
    }
  }
  function initiateCall() {
    initialize(document, "Freshdesk Messaging-js-sdk");
  }
  useEffect(() => {
    initiateCall();
    return () => {
      window.fcWidget.destroy();
    };
  }, []);

  useEffect(() => {
    console.log(window?.fcWidget?.isLoaded());
  }, [window?.fcWidget?.isLoaded()]);

  return (
    <div id="chat-id" className="" style={{direction: 'rtl'}}>
      {loading && <LoadingIndicator height={20} width={100} color={constant?.color?.DODGER_BLUE} />}
    </div>
  );
};

export default HelpDesk;
